
import { Reducer } from 'redux';
import { STATE } from 'app/constants';
import { mergeReducers } from 'app/infrastructure/redux/merge-reducers';
import { withOptionsReducer } from 'app/components/options-handler';
import { FavouriteAdminState } from './types-store';
import { reducer as favouriteAdminFormReducer, INITIAL_STATE as favouriteAdminFormState } from './form/reducers';
import { reducer as favouriteAdminListReducer, INITIAL_STATE as favouriteAdminListState } from './list/reducers';

export const INITIAL_STATE: FavouriteAdminState = {
  form: favouriteAdminFormState,
  list: favouriteAdminListState
};

export const reducer: Reducer<FavouriteAdminState> = withOptionsReducer(
  STATE.favouriteAdministration,
  mergeReducers({
    form: favouriteAdminFormReducer,
    list: favouriteAdminListReducer
  })
);
